export default "__VITE_ASSET__C8X0jSqH__"